import {useCallback, useEffect, useState} from "react";

import CliniciansService from "services/clinicians";
import {SEARCH_LIMIT} from "constants/paginationLimits";

export const useSearchDoctors = () => {
    const [doctors, setDoctors] = useState([]);

    const handleDoctorSearch = useCallback(
        async (string) => {
            try {
                const doctorsResponse = await CliniciansService.getCliniciansList({
                    limit: SEARCH_LIMIT,
                    query: string,
                });

                setDoctors(doctorsResponse.data);
            } catch {
                //empty
            }
        },
        [],
    )


    useEffect(() => {
        handleDoctorSearch();
    }, [handleDoctorSearch]);

    // value: the doctors.id sessions are booked against. userId: the person's account (users.id) - one
    // person can have more than one doctors row, so "the same doctor" is decided by this. isDeleted /
    // isBlocked: the account's state, for a picker that leaves those out (Move to another doctor); this
    // list itself leaves nobody out.
    const doctorsOptions = doctors.map(doctor => {
        return {
            value: doctor?.doctorId,
            label: `${doctor?.firstName} ${doctor?.lastName}`,
            userId: doctor?.id,
            isDeleted: Boolean(doctor?.isDeleted),
            isBlocked: Boolean(doctor?.isBlocked),
        }
    });

    return {
        handleDoctorSearch,
        doctorsOptions
    }
};
